export default [
  {
    title: '项目组ID',
    key: 'id',
    width: 48
  },
  {
    title: '项目组名称',
    key: 'name',
    width: 48
  },
  {
    title: '组成员',
    key: 'opNames',
    width: 48,
    overflow: true
  },
  {
    title: '负责人',
    key: 'manageNames',
    width: 48
  },
  {
    title: '项目组游戏',
    key: 'gameIds',
    width: 48
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 48
  },
  {
    title: '创建人',
    key: 'createOpName',
    width: 48
  },
  {
    title: '修改人',
    key: 'upOpName',
    width: 48
  },
  {
    title: '修改时间',
    key: 'updateTime',
    width: 48
  },
  {
    title: '操作',
    key: 'control',
    width: 48
  }
]
